<template >
  <div id="user-info-card">
    <div class="user-info-card-info mb-5">
      <div class="info-section">
        <div class="section-header">
          <h2>Basic info</h2>
          <TerminalBasicButton
            :buttonText="updateBasicInfo ? 'Save Change': 'Edit'"
            color="unibit-yellow"
            v-on:terminalBasicButtonClicked="handleChangeBasicInfo"
          ></TerminalBasicButton>
        </div>
        <div>
          <h3>Name</h3>
          <p class="mb-125">{{username}}</p>
          <h3>Email</h3>
          <p class="mb-125">{{getWindowLocalStorage('email')}}</p>
          <h3>Tel</h3>
          <input
            :class="(updateBasicInfo ? 'edit-field': 'readonly-field') +  ' mb-125'"
            :readonly="!updateBasicInfo"
            v-model.trim="newTelephone"
          />
        </div>
      </div>
      <div class="info-section">
        <div class="section-header">
          <h2>Password</h2>
          <TerminalBasicButton
            :buttonText="updatePassword ? 'Save Change': 'Edit'"
            color="unibit-yellow"
            v-on:terminalBasicButtonClicked="handleChangePassword"
          ></TerminalBasicButton>
        </div>
        <div class="info-update">
          <section>
            <h3 v-if="updatePassword">Old Password</h3>
            <input
              :readonly="!updatePassword"
              :class="(updatePassword ? 'edit-field': 'readonly-field') +  ' mb-125'"
              type="password"
              v-model.trim="oldPassword"
              placeholder="Old Password"
            />
            <h3 v-if="updatePassword">New Password</h3>
            <input
              v-if="updatePassword"
              class="edit-field mb-125"
              type="password"
              v-model.trim="newPassword"
              placeholder="New Password"
            />
            <h3 v-if="updatePassword">Confirm Password</h3>
            <input
              v-if="updatePassword"
              class="edit-field mb-125"
              type="password"
              v-model.trim="confirmPassword"
              placeholder="Confirm Password"
            />
          </section>
        </div>
      </div>
      <div class="info-section">
        <div class="section-header">
          <h2>Institution info</h2>
          <TerminalBasicButton
            :buttonText="updateInfo ? 'Save Change': 'Edit'"
            color="unibit-yellow"
            v-on:terminalBasicButtonClicked="handleInfoEdit"
          ></TerminalBasicButton>
        </div>
        <div class="info-update">
          <div>
            <h3>Institution</h3>
            <input
              :class="(updateInfo ? 'edit-field': 'readonly-field')  +  ' mb-125'"
              type="text"
              :readonly="!updateInfo"
              v-model.trim="newCompany"
            />
            <h3>Title</h3>
            <input
              :class="(updateInfo ? 'edit-field': 'readonly-field')  +  ' mb-125'"
              :readonly="!updateInfo"
              v-model.trim="newTitle"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TerminalBasicButton from "@/components/base/terminal-basic-button";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    label: {
      type: String,
      default: "label"
    }
  },

  components: {
    TerminalBasicButton
  },

  data() {
    return {
      newTitle: "",
      newTelephone: "",
      newCompany: "",
      updateInfo: false,
      updatePassword: false,
      updateBasicInfo: false,
      oldPassword: "1111111111",
      newPassword: "",
      confirmPassword: "",
      password_message: ""
    };
  },

  beforeMount() {
    this.newTitle = this.title;
    this.newCompany = this.company;
    this.newTelephone = this.formatPhoneNumber(this.telephone);
  },

  watch: {
    title() {
      this.newTitle = this.title;
    },
    company() {
      this.newCompany = this.company;
    },
    telephone() {
      this.newTelephone = this.formatPhoneNumber(this.telephone);
    }
  },

  computed: {
    username() {
      const firstname =
        this.firstname.substr(0, 1).toUpperCase() + this.firstname.substr(1);
      const lastname =
        this.lastname.substr(0, 1).toUpperCase() + this.lastname.substr(1);
      return firstname + " " + lastname;
    },

    token() {
      return this.getWindowLocalStorage("token");
    },

    ...mapState({
      firstname: state => state.UserService.userFirstName,
      lastname: state => state.UserService.userLastName,
      password: state => state.UserService.userPassword,
      company: state => state.UserService.companyName,
      title: state => state.UserService.positionTitle,
      telephone: state => state.UserService.telephoneNumber,
      loggedIn: state => state.UserService.idToken !== null
    })
  },
  methods: {
    handleInfoEdit() {
      this.updateInfo = !this.updateInfo;
      // user comfirm update info
      if (!this.updateInfo) {
        const {
          company,
          title,
          newCompany,
          newTitle,
          telephone,
          newTelephone,
          token
        } = this;
        newCompany.applyXSSprotection();
        newTitle.applyXSSprotection();

        if (company !== newCompany || newTitle !== title) {
          this.$store
            .dispatch("updateUserInsInfo", {
              token,
              company: newCompany,
              telephone: newTelephone,
              title: newTitle
            })
            .then(res => {
              this.$store.dispatch("notify", {
                info: "Update Institution info Successful",
                type: "success"
              });
              this.updateUserInfo(res);
              // console.log(res);
            })
            .catch(err => {
              this.$store.dispatch("notify", { info: err, type: "error" });
            });
        }
      }
    },

    handleChangeBasicInfo() {
      this.updateBasicInfo = !this.updateBasicInfo;
      if (!this.updateBasicInfo) {
        const {
          company,
          title,
          newCompany,
          newTitle,
          telephone,
          newTelephone,
          token
        } = this;
        newTelephone.applyXSSprotection();
        if (newTelephone != telephone) {
          // check whether phone number is valid
          if (!this.isPhone(this.newTelephone)) {
            this.$store.dispatch("notify", {
              info: "Invalid telephone number",
              type: "error"
            });
            this.updateBasicInfo = true;
            return;
          }
          this.newTelephone = this.formatPhoneNumber(this.newTelephone);
          this.$store
            .dispatch("updateUserInsInfo", {
              token,
              company: newCompany,
              telephone: newTelephone,
              title: newTitle
            })
            .then(res => {
              this.$store.dispatch("notify", {
                info: "Update Institution info Successful",
                type: "success"
              });
              this.updateUserInfo(res);
              // console.log(res);
            })
            .catch(err => {
              this.$store.dispatch("notify", { info: err, type: "error" });
            });
        }
      }
    },

    handleChangePassword() {
      this.updatePassword = !this.updatePassword;
      if (this.updatePassword) {
        this.oldPassword = "";
        this.newPassword = "";
        this.confirmPassword = "";
      }
      // change user password when updatePassword turn false
      else {
        const { token, oldPassword, newPassword, confirmPassword } = this;
        this.checkPasswordLength(newPassword);
        if (this.password_message) return;
        if (this.newPassword !== this.confirmPassword) {
          let error =
            "The confirmed password is different fromt he new password! ";
          this.$store.dispatch("notify", { info: error, type: "error" });
          this.updatePassword = true;
          return;
        }

        this.$store
          .dispatch("changeUserPassword", { token, oldPassword, newPassword })
          .then(res => {
            if (this.checkSamePassword(oldPassword, newPassword)) return;
            this.$store.dispatch("notify", {
              info: "Update Password Successful",
              type: "success"
            });
          })
          .catch(err => {
            let error = err.response.data.message;
            if (error === "username or password is incorrect!") {
              error = "Old password is Incorrect";
            }
            this.$store.dispatch("notify", { info: error, type: "error" });
            this.updatePassword = true;
          });
        this.oldPassword = "1111111111";
      }
    },

    /**
     * Function: Update user info in Vuex state
     */
    updateUserInfo(res) {
      const { company, telephone, title } = res.data;
      this.$store.commit("setCompanyName", company);
      this.$store.commit("setPositionTitle", title);
      this.$store.commit("setTelephone", telephone);
    },

    checkPasswordLength(password) {
      // get the global constant
      const len = this.$globalConstants.MIN_PASSWORD_LENGTH || 10;
      if (password.length < len) {
        this.password_message = `*Password must be at least ${len} characters long`;
      } else {
        this.password_message = "";
      }

      if (this.password_message) {
        this.$store.dispatch("notify", {
          info: this.password_message,
          type: "error"
        });
        this.updatePassword = true;
      }
    },

    checkSamePassword(oldPassword, newPassword) {
      if (oldPassword === newPassword) {
        this.$store.dispatch("notify", {
          info: "Input new password is same as old one",
          type: "error"
        });
        return true;
      }
      return false;
    }
  }
};
</script>


<style lang="css" scoped>
* {
  font-family: Raleway;
  font-size: 0.875rem;
  /* font-weight: bold; */
  color: #656666;
  letter-spacing: 0.56px;
}

#user-info-card {
  background-color: white;
  height: 100%;
  overflow: auto;
}

.user-info-card-info {
  padding: 1rem;
}

.info-section {
  margin-bottom: 1rem;
}

.info-section h2 {
  /* font-size: 24px; */
  /* padding: 1rem 1.5rem; */
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0px;
}

.info-section h3 {
  font-size: 1rem;
  font-weight: 600;
}

.mb-125 {
  margin-bottom: 1.25rem;
}

.readonly-field {
  background: transparent;
  border: 0;
  outline: 0;
}

.edit-field {
  color: #4a4a4a;
  border-radius: 4px;
  border: none;
  box-shadow: inset 0 0 3px 0 rgba(134, 134, 134, 0.5);
}

.edit-field:focus {
  outline: 0.4px solid #f5a623;
}

input {
  padding: 0.1rem 1rem;
}

.update-input {
  border: 0;
  outline: 0;
  background: transparent;
}

.info-section > div {
  background-color: white;
  padding: 1rem 1.5rem;
}

.section-header {
  padding-bottom: 0 !important;
  margin-bottom: 2px;
  border-bottom: solid 0.4px rgba(151, 151, 151, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-update {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.info-update > div > p {
  margin: 5px 0;
}

.place-holder {
  height: 2.5rem;
}

@media only screen and (min-width: 992px) {
  * {
    font-size: 1rem;
    letter-spacing: 0.47px;
  }
  .info-update > div input {
    min-width: 400px;
  }

  #user-info-card {
    padding: 3rem 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/user-info-card.vue